import { UserDb } from 'lib/cosmos/user/userDb';
import { SimpleTableItem } from 'lib/ui/simple-table';
import { TimeService } from 'src/app/services/time.service';

export class UserAdminHelper {
	getOverUserSimpleTableItems(user: UserDb.IUserItem, timeService: TimeService): SimpleTableItem[] {
		const items: SimpleTableItem[] = [
			{
				iconType: 'id',
				title: 'User id',
				value: user.id,
				valueType: 'text'
			},
			{
				iconType: 'email',
				title: 'E-mail',
				value: user.email,
				valueType: 'text'
			},
			{
				iconType: 'timezone',
				title: 'Timezone',
				value: user.timezone,
				valueType: 'text'
			},
			{
				iconType: 'referrer',
				title: 'Referrer',
				value: user.referrer,
				valueType: 'text'
			},
			{
				iconType: 'user_pen',
				title: 'Name',
				value: user.fullName,
				valueType: 'text'
			},
			{
				iconType: 'user',
				title: 'User type',
				value: user.userType,
				valueType: 'text'
			},
			{
				iconType: 'purchase',
				title: 'License',
				value: user.license,
				valueType: 'text'
			},
			{
				iconType: 'browser',
				title: 'Browser',
				value: user.browser ? `${user.browser.browserName} ${user.browser.browserVersion}` : 'n/a',
				valueType: 'text'
			},
			{
				iconType: 'date',
				title: 'Last active',
				value: user.lastActiveDate ? `${timeService.fromNow(user.lastActiveDate)}` : 'n/a',
				valueType: 'text'
			},
			{
				iconType: 'date',
				title: 'Joined',
				value: `${timeService.formatDateTime(user.system.created)}`,
				valueType: 'text'
			},

			{
				iconType: 'emailConfirm',
				title: 'E-mail confirmed',
				value: user.emailConfirmed ? 'yes' : 'no',
				valueType: 'text'
			},

			{
				iconType: 'delete',
				title: 'Is deleted',
				value: user.isDeleted ? 'yes' : 'no',
				valueType: 'text'
			},
			{
				iconType: 'email',
				title: 'Is unsubscribed',
				value: user.unsubscribeFromEmails ? 'yes' : 'no',
				valueType: 'text'
			},
			{
				iconType: 'disabled',
				title: 'Is disabled',
				value: user.isDisabled ? 'yes' : 'no',
				valueType: 'text'
			}
		];

		return items;
	}
}

export const userAdminHelper = new UserAdminHelper();
